






import { getImageUrlByBackend } from '@api/helpers/url/imageUrl';
import {Element} from "@api/models/Element";
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class StatusIcon extends Vue {
  @Prop({ default: 44 }) size!: number;
  @Prop() status!: Element;

  get sideSize(): string {
    return this.size + 'px';
  }

  get iconCssStyle(): Record<string, any> {
    return {
      background: this.iconColor,
      width: this.sideSize,
      height: this.sideSize,
      flex: '0 0 ' + this.sideSize,
      lineHeight: this.sideSize,
    };
  }

  get iconColor() {
    return this.status.color || '#979299';
  }

  get iconSrc() {
    if (!this.status || !this.status.iconFileId) {
      return '';
    }
    return getImageUrlByBackend(this.$store.state.session.backend, this.status.iconFileId);
  }
}
